import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createModules, fetchModules, removeModules, updateModules } from "../../service/api";


export const getModules = createAsyncThunk(
    "modules/getAll",
    async (params, { rejectWithValue }) => {
        console.log("params", params)
        try {
            const response = await fetchModules(params)
            console.log("fetch module", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)

// export const getConsultationById = createAsyncThunk(
//     "consultations/consultationById",
//     async (params, { rejectWithValue }) => {
//         try {
//             const response = await fetchConsultationById(params)
//             console.log("response", response)
//             return response.data
//         } catch (error) {
//             return rejectWithValue(err.response?.data || err.message)
//         }
//     }
// )

export const addModules = createAsyncThunk(
    "modules/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createModules(formValue)
            if (response.status === 201) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editModules = createAsyncThunk(
    "modules/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateModules(newData)
            if (response.status === 201) {
                console.log("edit modules", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


export const deleteModules = createAsyncThunk(
    "modules/delete",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await removeModules(newData)
            if (response.status === 201) {
                console.log("edit modules", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



const modulesSlice = createSlice({
    name: "modules",
    initialState: {
        modulesList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: null
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getModules.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getModules.fulfilled, (state, action) => {
                state.isLoading = false;
                state.modulesList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getModules.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //by id

            // .addCase(getConsultationById.pending, (state) => {
            //     state.error = null
            // })
            // .addCase(getConsultationById.fulfilled, (state, action) => {
            //     state.consultationById = action.payload.data;

            // })
            // .addCase(getConsultationById.rejected, (state, action) => {
            //     state.error = action.payload
            // })


            // POST

            .addCase(addModules.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addModules.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addModules.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editModules.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editModules.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editModules.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteModules.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteModules.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteModules.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setSearchParams, setPagination } = modulesSlice.actions;

export default modulesSlice.reducer;